export enum RedoShopifyOrderDisputeStatus {
  ACCEPTED = "ACCEPTED",
  LOST = "LOST",
  NEEDS_RESPONSE = "NEEDS_RESPONSE",
  UNDER_REVIEW = "UNDER_REVIEW",
  WON = "WON",
  CHARGE_REFUNDED = "CHARGE_REFUNDED",
}

export enum RedoShopifyOrderDisputeInitiatedAs {
  CHARGEBACK = "CHARGEBACK",
  INQUIRY = "INQUIRY",
}
